import { AxiosResponse } from "axios";
import { HttpService } from "@/core";
import { ResponseResp } from "@/core/interface";
import { message } from "ant-design-vue";
import ArrayToTree from "array-to-tree";
import {
  DepartmentDetailResp,
  DepartmentListResp,
  DepartmentReq,
  DepartmentSimpleListReq,
  DepartmentSimpleListResp,
  DepartmentSimpleRecord,
  DepartmentUserRecord,
  DepartmentUserResp,
} from "./department.interface";

export class DepartmentService {
  /**
   * 获取部门下的员工
   * @param {number} departmentId 部门ID
   */
  static async fetchUserList(state,departmentId: number,staffType?): Promise<DepartmentUserRecord[]> {
    let records: DepartmentUserRecord[] = [];
    try {
      const r: AxiosResponse<ResponseResp<DepartmentUserResp>> = await HttpService.axios({
        method: "GET",
        url: `/department_user/${departmentId}/users`,
        params:{
         state:state.state,
         staffType:staffType,
         activatedStatus:state.activatedStatus,
        }
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return records;
      }
      records = res.data.records || [];
    } catch (e: any) {
      message.error(e.message);
    }
    return records;
  }

  static useFullListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/department/full/list",
        params
      });
    return HttpService.useRequest<DepartmentListResp>(api);
  }

  static useSimpleListApi() {
    const api = (params: DepartmentSimpleListReq) =>
      HttpService.axios({
        method: "GET",
        url: "/department/simple/list",
        params,
      });
    return HttpService.useRequest<DepartmentSimpleListResp>(api, {
      formatResult: (resp) => {
        resp.records = ArrayToTree(resp.records || [], {
          parentProperty: "parentId",
          customID: "id",
        });
        return resp;
      },
    });
  }

  static async fetchSimpleList(params: DepartmentSimpleListReq): Promise<DepartmentSimpleRecord[]> {
    let records: DepartmentSimpleRecord[] = [];
    try {
      const r: AxiosResponse<ResponseResp<DepartmentSimpleListResp>> = await HttpService.axios({
        method: "GET",
        url: "/department/simple/list",
        params,
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return records;
      }
      records = (res.data.records || []).map((item) => {
        if (item.hasChildren && item.hasEmployee) {
          item.children = [];
        }
        item.isLeaf = !item.hasChildren && !item.hasEmployee;
        return item;
      });
    } catch (e: any) {
      message.error(e.message);
    }
    return records;
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/department/${id}`,
      });
    return HttpService.useRequest<DepartmentDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: DepartmentReq) =>
      HttpService.axios({
        method: "POST",
        url: "/department",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: DepartmentReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/department/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/department/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
}
